import React, { memo } from 'react';
import { Handle, Position } from 'reactflow';

const typeLabels = {
  gather: 'Erfassen',
  transform: 'Verarbeiten',
  validate: 'Prüfen',
  decide: 'Entscheiden',
  produce: 'Erstellen',
  communicate: 'Kommunizieren',
};

function ProcessNode({ data }) {
  const isLiteAgent = data.isLiteAgent;
  const liteRank = data.liteAgentRank;
  const stepNumber = data.stepNumber;

  return (
    <div className={`process-node ${isLiteAgent ? 'lite-agent-highlight' : ''}`}>
      <Handle type="target" position={Position.Left} className="node-handle" />

      {isLiteAgent && liteRank && (
        <div className="node-badge-row">
          <span className="node-badge lite-agent-badge">
            {data.liteAgentSuggested ? 'Empfohlener Lite Agent' : 'Lite Agent'} #{liteRank}
          </span>
        </div>
      )}

      <div className="node-header">
        <span className="node-step-number">{stepNumber || ''}</span>
        <span className="node-title">{data.name}</span>
      </div>

      <div className="node-description">{data.description}</div>

      <div className="node-meta">
        {data.type && (
          <span className="node-meta-tag">{typeLabels[data.type] || data.type}</span>
        )}
        {data.isBottleneck && (
          <span className="node-meta-tag bottleneck">Engpass</span>
        )}
        {data.primaryCapability && (
          <span className="node-meta-tag capability">{data.primaryCapability.class}</span>
        )}
        {!data.isLiteAgent && data.level && data.level !== 'L2' && (
          <span
            className="node-meta-tag not-mvp"
            title="Diese Empfehlung kannst du im AI-Day Playground heute nicht selbst bauen. Sie ist eine Option für die spätere Umsetzung in deinem Tagesgeschäft."
          >
            Noch nicht verfügbar (nicht MVP)
          </span>
        )}
      </div>

      {data.automationPotential && (
        <div className={`node-potential potential-${data.automationPotential}`}>
          Potenzial: {data.automationPotential === 'hoch' ? 'Hoch' : data.automationPotential === 'mittel' ? 'Mittel' : 'Niedrig'}
        </div>
      )}

      <Handle type="source" position={Position.Right} className="node-handle" />
    </div>
  );
}

export default memo(ProcessNode);
